import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from './CloseButton.styles';

interface CloseButtonProps {
  onClick: () => void;
  ariaLabel?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, ariaLabel }) => {
  const classes = useStyles();
  return (
    <button onClick={onClick} className={classes.closeButton} aria-label={ariaLabel ?? 'Zamknij'} aria-hidden="false">
      <div className={classes.xInButton}>
        <CloseIcon style={{ fontSize: '15px' }}></CloseIcon>
      </div>
    </button>
  );
};

export default CloseButton;
